import API from '@/api/path'
import { baseFetch } from '@/api/axiosBase'

const fileModule = {
  state: {},
  actions: {
    // 上傳檔案
    async UPLOAD_FILE({ dispatch }, payload) {
      try {
        // console.log('UPLOAD_FILE payload: ', payload)
        const { file } = payload
        const uid = file.uid

        const byteSize = file.size
        // const kbSize = byteSize / 1024
        // const mbSize = kbSize / 1024
        // console.log('mbSize: ', mbSize)
        const attrsParams = { fileSize: byteSize }
        let formParams = new FormData()
        formParams.append('File1', file)
        formParams.append('attrs', JSON.stringify(attrsParams))

        const res = await baseFetch(
          API.uploadFile.url,
          API.uploadFile.method,
          formParams,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        )
        // console.log('UPLOAD_FILE res: ', res)
        if (!res.isError && res.data) {
          const fileId = res.data.fileid
          const fileMetaResponse = await dispatch('GET_FILE_META', { fileId })
          // console.log('fileMetaResponse: ', fileMetaResponse)
          const feedbackRes = {
            uid,
            fileId,
            ...fileMetaResponse.data
          }
          feedbackRes.fileSize = fileMetaResponse.data.attr.fileSize
            ? fileMetaResponse.data.attr.fileSize
            : 0
          return feedbackRes
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    // 取得檔案資訊
    async GET_FILE_META(_, payload) {
      // console.log('GET_FILE_META payload: ', payload)
      try {
        const { fileId } = payload
        const res = await baseFetch(
          API.getFileMeta.url,
          API.getFileMeta.method,
          { fileId }
        )
        // console.log('GET_FILE_META res: ', res)
        if (!res.isError && res.data) {
          return res.data
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    // TODO 下載檔案
    async DOWNLOAD_FILE(_, { fileId, ...payload }) {
      console.log('DOWNLOAD_FILE fileId: ', fileId)
      try {
        const res = await baseFetch(
          API.downloadFile.url(fileId),
          API.downloadFile.method,
          payload
        )
        console.log('res: ', res)
        // if (!res.isError && res.data) {
        //   commit('SET_COMMUNITIES', res.data.data)
        // }
      } catch (error) {
        console.error('error', error)
      }
    },
    // !注意 cfs api 回傳 res.data.result == 0 
    // !與webapi 不同，axiosBase.js會判定錯誤，不能使用!res.isError
    // 新增Meta資訊
    UPLOAD_META(_, payload) {
      // 回到頁面處理，根據回傳meta，UPLOAD_FILE_BY_META上傳檔案
      return baseFetch(
        API.uploadMetaData.url,
        API.uploadMetaData.method,
        payload
      )
    },
    //TODO 以下TODO皆待使用驗證或修改
    //TODO 上傳檔案到Meta指定的位置
    async UPLOAD_FILE_BY_META(_, { fileId, ...payload }) {
      try {
        const res = await baseFetch(
          API.uploadFileByMeta.url(fileId),
          API.uploadFileByMeta.method,
          payload
        )
        console.log('res: ', res)
        // if (res.data?.result === 0) {
        // }
      } catch (error) {
        console.error('error', error)
      }
    },
    //TODO 刪除檔案
    DELETE_FILE(_, { fileId, ...payload }) {
      return baseFetch(
        API.deleteFile.url(fileId),
        API.deleteFile.method,
        payload
      )
    },
    // 查詢檔案meta data
    async GET_META_DATA(_, { fileId, ...payload }) {
      try {
        const res = await baseFetch(
          API.getMetaData.url(fileId),
          API.getMetaData.method,
          payload
        )
        console.log('file meta res: ', res)
        if (res.data?.result === 0) {
          return res.data
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    //TODO 修改meta資訊
    async UPDATE_META_DATA(_, { fileId, ...payload }) {
      try {
        const res = await baseFetch(
          API.updateMetaData.url(fileId),
          API.updateMetaData.method,
          payload
        )
        console.log('res: ', res)
        // if (res.data?.result === 0) {
        // }
      } catch (error) {
        console.error('error', error)
      }
    },
    //TODO 更新檔案attr
    async UPDATE_META_ATTR(_, { fileId, ...payload }) {
      try {
        const res = await baseFetch(
          API.updateMetaAttr.url(fileId),
          API.updateMetaAttr.method,
          payload
        )
        console.log('res: ', res)
        // if (res.data?.result === 0) {
        // }
      } catch (error) {
        console.error('error', error)
      }
    },
    // 查詢meta清單 (attr必帶，至少為{})
    // 要帶上些條件，不然會撈回全部的資料
    GET_META_LIST(_, payload) {
      // 回到頁面處理
      return baseFetch(
        API.getMetaDataList.url,
        API.getMetaDataList.method,
        payload
      )
    },
    // 預約下載
    SCHEDULE_DOWNLOAD(_, { nvrId, ...payload }) {
      return baseFetch(
        API.scheduleDownload.url(nvrId),
        API.scheduleDownload.method,
        payload
      )
    },
    // 重新下載
    RE_DOWNLOAD(_, { nvrId, ...payload }) {
      return baseFetch(
        API.reDownload.url(nvrId),
        API.reDownload.method,
        payload
      )
    }
  },
  mutations: {},
  getters: {},
  namespaced: true
}

export default fileModule
